import { FC } from 'react'
import { TagLabelWrapper } from './tagLabel.styles'
import { BetaTag } from '../../../components/tags'

interface Props {
  header: string
  isSnowflake: boolean
  isActive?: boolean
}

const TagLabel: FC<Props> = ({ header, isSnowflake, isActive }) => (
  <TagLabelWrapper>
    {header}
    {isSnowflake && <BetaTag isActive={isActive} />}
  </TagLabelWrapper>
)

export default TagLabel
